<template>
    <breadCrumbs title="Avatars" main="UI Kits" title1="Avatars" />
    <div class="container-fluid">
            <div class="user-profile">
              <div class="row">
                  <sizing/>
                  <shape/>
              </div>
            </div>
        </div>
</template>
<script>
import sizing from "./sizingPage.vue"
import shape from "./shapePage.vue"
export default {
    components:{
        sizing,
        shape
    }
}
</script>